<template>
  <div class="profile__information">
    <div v-if="!hasLabels" class="profile__no-content">
      {{ $t("label-info") }}
    </div>
    <transition-group
      v-else-if="userLabels.length <= 4 || labelManager"
      name="lightSpeed"
    >
      <div
        v-for="(label, index) in userLabels"
        :key="label.key"
        class="profile__information-item"
        style="animation-duration: 0.5s"
      >
        <div class="profile__information-col">
          <div class="profile__information-label">
            <div class="profile__information-label-value">
              <div
                v-if="shortenValue(label.key)"
                v-tooltip="label.key"
                class="profile__information-label-title"
              >
                {{ label.key | truncate(labelManager ? 50 : 16) }}
              </div>
              <div v-else class="profile__information-label-title">
                {{ label.key }}
              </div>
            </div>
          </div>
          <div class="profile__information-value">
            <div
              v-if="shortenValue(label.value)"
              v-tooltip="label.value"
              class="profile__information-label-text"
            >
              {{ label.value | truncate(labelManager ? 50 : 16) }}
            </div>
            <div class="profile__information-label-text" v-else>
              {{ label.value }}
            </div>
          </div>
        </div>
        <div v-if="remove" class="profile__information-icon">
          <cancel-icon @click="deleteLabel(label.key, index)" />
        </div>
      </div>
    </transition-group>
    <transition-group v-else name="fade" mode="in-out">
      <div
        v-for="(label, index) in showAll ? userLabels : userLabelsLimit"
        :key="label.key"
        class="profile__information-item"
        style="animation-duration: 0.5s"
      >
        <div class="profile__information-col">
          <div class="profile__information-label">
            <div class="profile__information-label-value">
              <div
                v-if="shortenValue(label.key)"
                v-tooltip="label.key"
                class="profile__information-label-title"
              >
                {{ label.key | truncate(labelManager ? 50 : 16) }}
              </div>
              <div v-else class="profile__information-label-title">
                {{ label.key }}
              </div>
            </div>
          </div>
          <div class="profile__information-value">
            <div
              v-if="shortenValue(label.value)"
              v-tooltip="label.value"
              class="profile__information-label-text"
            >
              {{ label.value | truncate(labelManager ? 50 : 16) }}
            </div>
            <div class="profile__information-label-text" v-else>
              {{ label.value }}
            </div>
          </div>
        </div>
        <div v-if="remove" class="profile__information-icon">
          <cancel-icon @click="deleteLabel(label.key, index)" />
        </div>
      </div>
      <div
        key="buttonShow"
        @click="toggleShow"
        class="profile__information-more"
      >
        {{ !showAll ? $t("chat.show-all") : $t("chat.show-less") }}
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: {
    userLabels: {
      type: Array,
      required: true,
      default: () => [],
    },
    remove: {
      type: Boolean,
      default: false,
    },
    labelManager: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CancelIcon: () => import('@/assets/icons/cancel.svg'),
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    hasLabels() {
      return this.userLabels.length > 0;
    },
    userLabelsLimit() {
      return this.userLabels.length > 4 ? this.userLabels.slice(0, 4) : this.userLabels;
    },

  },
  methods: {
    deleteLabel(key, ix) {
      this.$emit('remove-label', { key, ix });
    },
    shortenValue(value) {
      return (!this.labelManager && value.length > 18)
      || (this.labelManager && value.length > 55);
    },
    toggleShow() {
      this.showAll = !this.showAll;
    },
  },
};
</script>
